import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import type { Organization } from "types";

const processOptions = (options: Organization[]) =>
  options.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

function OrganizationSelect(props: any) {
  return (
    <RemoteSelect
      url="organizations"
      processOptions={processOptions}
      {...props}
    />
  );
}

export default OrganizationSelect;
